import { Link } from "react-router-dom";
import { Activity, ArrowRight } from "lucide-react";
import Seo from "../lib/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { SEO_MODALITIES, MODALITY_SLUGS } from "../lib/seoPages";

export default function Modalidades() {
    return (
        <>
            <Seo
                title="Modalidades de rehabilitación de drogas en Chile"
                description="Compara modalidades de rehabilitación de drogas en Chile: residencial, ambulatoria, online y programas para mujeres y adolescentes."
                path="/modalidades"
                keywords="modalidades rehabilitación, rehabilitación residencial, rehabilitación ambulatoria, rehabilitación online"
            />

            <section className="border-b border-slate-800 bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <Breadcrumbs
                        items={[
                            { name: "Inicio", path: "/" },
                            { name: "Modalidades" },
                        ]}
                    />
                    <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-300">
                        <Activity className="h-3.5 w-3.5" />
                        Tipos de tratamiento
                    </div>
                    <h1 className="mt-5 text-3xl font-bold tracking-tight text-slate-50 sm:text-5xl">
                        Modalidades de rehabilitación de drogas
                    </h1>
                    <p className="mt-3 max-w-2xl text-slate-400">
                        Cada caso requiere la modalidad adecuada. Conoce las opciones
                        disponibles en Chile y elige con criterios clínicos claros.
                    </p>
                </div>
            </section>

            <section className="py-12">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {MODALITY_SLUGS.map((slug) => {
                            const m = SEO_MODALITIES[slug];
                            return (
                                <Link
                                    key={slug}
                                    to={`/modalidades/${slug}`}
                                    data-testid={`modality-card-${slug}`}
                                    className="card-hover group rounded-xl border border-slate-800 bg-slate-900 p-6"
                                >
                                    <div className="flex items-center gap-2 text-cyan-400">
                                        <Activity className="h-4 w-4" />
                                        <span className="text-xs font-medium uppercase tracking-wider">
                                            Modalidad
                                        </span>
                                    </div>
                                    <h2 className="mt-3 text-xl font-semibold text-slate-50 group-hover:text-cyan-400">
                                        {m.name}
                                    </h2>
                                    <p className="mt-2 text-sm text-slate-400">
                                        {m.desc}
                                    </p>
                                    <div className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-cyan-400">
                                        Conocer más{" "}
                                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
}
